import styled from "@emotion/styled";

const PageContent = styled('div')`
    display: flex;
    flex-direction: column;
    row-gap: 40px;
    align-items: center;
    
    header {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        text-align: center;
        width: 100%;
        
        h2 {
            font-weight: 400;
        }
        
        p {
            font-size: 18px;
            margin-top: 8px;
        }
    }

    footer {
        text-align: right;
        
        &.full-width {
            width: 100%;
        }
    }
`

export default PageContent